var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
    [
      _vm.deviceStatusLoading == false
        ? [
            _vm.authorities.GET_DASHBOARD ||
            _vm.checkRole == "private" ||
            _vm.checkRole == "branch"
              ? _c(
                  "v-col",
                  {
                    staticClass: "ma-0 pa-1 mb-8 pt-0 pl-5 pr-5",
                    attrs: { cols: "12", id: "cctv_status_box" },
                  },
                  [
                    _c(
                      "v-row",
                      { staticClass: "ma-0 pa-0", attrs: { align: "start" } },
                      [
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "4" } },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { align: "center" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { id: "chart_box", cols: "4" },
                                  },
                                  [
                                    _c("DoughnutChart", {
                                      attrs: {
                                        data: _vm.cctvChartData,
                                        options: _vm.chartOptions,
                                        plugins: _vm.chartPlugins,
                                        width: 100,
                                        height: 100,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-5 pl-0 pr-10",
                                    attrs: { cols: "8" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0 pb-3",
                                        attrs: {
                                          align: "end",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 pb-1",
                                            attrs: { cols: "auto" },
                                          },
                                          [_vm._v(_vm._s(_vm.td("cctvCount")))]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              align: "end",
                                              justify: "end",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                staticStyle: {
                                                  "font-size": "1.75rem",
                                                },
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(_vm.totalCCTVCnt))]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 pb-1 pl-1",
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(_vm.td("ea")))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0 pb-3",
                                        attrs: {
                                          align: "center",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c("v-img", {
                                              staticClass: "ma-0 pa-0 mr-2",
                                              attrs: {
                                                "max-height": "1rem",
                                                "max-width": "1rem",
                                                src: require("@/assets/images/blue_box.png"),
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.td("online")) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              align: "end",
                                              justify: "end",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                staticStyle: {
                                                  "font-size": "1.35rem",
                                                },
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.deviceStatusData.uac
                                                      .online
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 pb-1 pl-1",
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(_vm.td("ea")))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          align: "center",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c("v-img", {
                                              staticClass: "ma-0 pa-0 mr-2",
                                              attrs: {
                                                "max-height": "1rem",
                                                "max-width": "1rem",
                                                src: require("@/assets/images/grey_box.png"),
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.td("offline")) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              align: "start",
                                              justify: "end",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.deviceStatusData.uac
                                                      .offline
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 pb-1 pl-1",
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(_vm.td("ea")))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "4" } },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { align: "center" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { id: "chart_box", cols: "4" },
                                  },
                                  [
                                    _c("DoughnutChart", {
                                      attrs: {
                                        data: _vm.aiCameraChartData,
                                        options: _vm.chartOptions,
                                        plugins: _vm.chartPlugins,
                                        width: 100,
                                        height: 100,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-5 pl-0 pr-10",
                                    attrs: { cols: "8" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0 pb-3",
                                        attrs: {
                                          align: "end",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 pb-1",
                                            attrs: { cols: "auto" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.td("alCameraCount"))
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              align: "end",
                                              justify: "end",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                staticStyle: {
                                                  "font-size": "1.75rem",
                                                },
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.totalAiCameraCnt)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 pb-1 pl-1",
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(_vm.td("ea")))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0 pb-3",
                                        attrs: {
                                          align: "center",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c("v-img", {
                                              staticClass: "ma-0 pa-0 mr-2",
                                              attrs: {
                                                "max-height": "1rem",
                                                "max-width": "1rem",
                                                src: require("@/assets/images/blue_box.png"),
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.td("online")) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              align: "end",
                                              justify: "end",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                staticStyle: {
                                                  "font-size": "1.35rem",
                                                },
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.deviceStatusData.uas
                                                      .online
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 pb-1 pl-1",
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(_vm.td("ea")))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          align: "center",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _c("v-img", {
                                              staticClass: "ma-0 pa-0 mr-2",
                                              attrs: {
                                                "max-height": "1rem",
                                                "max-width": "1rem",
                                                src: require("@/assets/images/grey_box.png"),
                                              },
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.td("offline")) +
                                                " "
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              align: "start",
                                              justify: "end",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.deviceStatusData.uas
                                                      .offline
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 pb-1 pl-1",
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(_vm.td("ea")))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "ma-0 pa-0", attrs: { cols: "4" } },
                          [
                            _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { align: "center" },
                              },
                              [
                                _c("v-col", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { cols: "4" },
                                }),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-5 pl-0 pr-10",
                                    attrs: { cols: "8" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          align: "end",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 pb-1",
                                            attrs: { cols: "auto" },
                                          },
                                          [_vm._v(_vm._s(_vm.td("storeCount")))]
                                        ),
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              align: "end",
                                              justify: "end",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                staticStyle: {
                                                  "font-size": "1.75rem",
                                                },
                                                attrs: { cols: "auto" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.deviceStatusData
                                                      .storeCnt
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "ma-0 pa-0 pb-1 pl-1",
                                                attrs: { cols: "auto" },
                                              },
                                              [_vm._v(_vm._s(_vm.td("store")))]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : [
            _c(
              "v-col",
              {
                staticClass: "ma-0 mb-8 pa-3",
                attrs: { cols: "12", id: "cctv_status_box", align: "center" },
              },
              [
                _c("ImageSkeleton", {
                  attrs: { loaderCount: 3, width: "90%", height: "126px" },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }